import React, { useState, useEffect } from 'react'
import { components, useServices, useTranslation } from 'cng-web-lib'
import Namespace from '../../../constants/locale/Namespace'
import AceHighwayAbiInbond7512Keys from 'src/constants/locale/key/AceHighwayAbiInbond7512'
import AceHighwayAbiInbond7512ApiUrls from 'src/apiUrls/AceHighwayAbiInbond7512ApiUrls'
import { Box, Grid, Paper } from '@material-ui/core'
import { FileForUserGetUserDetails } from 'src/common/FileForUserCommon'
import ErrorMessageSection from 'src/views/common/ErrorMessageSection'
import ACEHighwayShipmentTranslationText from '../contexts/ACEHighwayShipmentTranslationText'
import ACEHighwayInbond7512TranslationText from '../contexts/ACEHighwayInbond7512TranslationText'
import NaCommonTranslationText from 'src/common/NaCommonTranslationText'
import ACEHighwayManifestTranslationText from '../contexts/ACEHighwayManifestTranslationText'

const {
  button: { CngButton },
  dropzone: { CngFileUpload },
  CngDialog
} = components

function Inbond7512UploadDialog(props) {
  const { onClose, open, showNotification } = props

  const [files, setFiles] = useState([])
  const [errorMessages, setErrorMessages] = useState([])
  const [loading, setLoading] = useState(false)
  const { securedSendRequest } = useServices()
  const { translate } = useTranslation(Namespace.ACE_HIGHWAY_ABI_INBOND_7512)
  const shipmentTranslatedTextsObject = ACEHighwayShipmentTranslationText()
  const translatedTextsObject = ACEHighwayInbond7512TranslationText()
  const manifestTranslatedTextsObject = ACEHighwayManifestTranslationText()
  const commonTranslatedTextsObject = NaCommonTranslationText()


  useEffect(() => {
    setFiles([])
    setErrorMessages([])
  }, [open]);

  const downloadFile = () => {
    const blob = new Blob(["S NO,Acct ID,User ID,FilerCode,Entry Type,Bond Number,Carrier Code,Port of Destination,Foreign Port,In-bond Value,In-bond Carrier Type,Inbond Carrier ID,Mode of Transport,ETA,Carrier Code,Port of Arrival,Master Bill of Lading Carrier Code,Master Bill Number,Action Code,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,, , \n,\"O\,6AN\"\,\"O\,10AN\"\,\"O\,3AN\"\,\"M\,2AN\"\,\"M\,12AN\"\,\"M\,4AN\"\,\"M\,4N\"\,\"M\,5N\"\,\"M\,8N\"\,\"C\,3A\"\,\"C\,12X\"\,\"N,2N\"\,\"M\,MM-DD-YYYY\"\,\"M\,4AN\"\,\"M\,4AN\"\,\"M\,12AN\"\,\"M\,12AN\"\,\"M\,1A\",,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,\n,,,INBOND HEADER,,,,,,,,,Conveyance Information,,,,Bill of Lading Header,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,\n1,fdxc,fdxc001,TBB,61,6998702913,FDE,0101,01520,45,IRS,12-8976238AB,30,8/18/1997,1234,3801,EFGH,6696898,A,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,"], { type: "text/csv" })
    const element = document.createElement("a");
    element.href = window.URL.createObjectURL(blob)
    element.download = "ACEHWY_Inbond7512_SampleUpload.csv";
    document.body.appendChild(element);
    element.click();
    element.parentNode.removeChild(element);
  }

  function handleUploadInbond7512() {
    try {
      setLoading(true)

      let fileForUserDetails = FileForUserGetUserDetails();
      const formData = new FormData()

      formData.append('file', files[0].file)
      if (fileForUserDetails != null && fileForUserDetails != undefined) {
        formData.append("fileForUserDetails", JSON.stringify(fileForUserDetails))
      } else {
        formData.append("fileForUserDetails", "{}")
      }

      securedSendRequest.execute(
        'POST',
        AceHighwayAbiInbond7512ApiUrls.UPLOAD,
        formData,
        (response) => {
          if (response.status === 200) {
            if (response.data) {
              const errorMessages = response.data.errorMessages

              if (errorMessages) {
                setErrorMessages(errorMessages)
                setFiles([])
              }
            } else {
              showNotification('success', shipmentTranslatedTextsObject.uploadSuccessMsg)
              onClose()
              open.tableRef.current.performRefresh()
            }
          }
        },
        () => {
          showNotification('error', translatedTextsObject.uploadInbondErrorMsg)
          setFiles([])
        },
        () => setLoading(false)
      )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <CngDialog
      dialogTitle={translatedTextsObject.uploadNewInbond}
      dialogContent={
        <Paper variant='outlined'>
          <Box padding={2}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <CngFileUpload
                  accept={['.csv']}
                  files={files}
                  maxFiles={1}
                  maxSize={5.3e+7}
                  onFileSelect={(file) => setFiles(file)}
                  showFormFields={false}
                  moreActions={[
                    {
                      action: 'remove',
                      name: commonTranslatedTextsObject.removeButton,
                      icon: ['fal', 'trash']
                    }
                  ]}
                  onDropRejected={(errorMessages) => console.log(errorMessages)}
                />
              </Grid>

              <ErrorMessageSection errorMessages={errorMessages} />

              <Grid item xs={12}>
                <Grid container justify='flex-end' spacing={2}>
                  <Grid item xs='auto'>
                    <CngButton size='medium' variant='outlined' onClick={downloadFile}>
                      {shipmentTranslatedTextsObject.downloadTemplateCsv}
                    </CngButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      }
      dialogAction={
        <>
          <CngButton color='secondary' disabled={loading} onClick={onClose}>
            {manifestTranslatedTextsObject.discardButton}
          </CngButton>
          <CngButton
            color='primary'
            disabled={loading}
            onClick={handleUploadInbond7512}
            shouldShowProgress={loading}
          >
            {translatedTextsObject.saveButton}
          </CngButton>
        </>
      }
      fullWidth
      maxWidth='lg'
      open={open.open}
      onClose={onClose}
      shouldShowCloseButton
    />
  )
}

export default Inbond7512UploadDialog
